import React from 'react'

import Header from './../Header';
import './Book.css'

const book = props => (
  <div className="book_row">
    <div className="book_col left">
      <Header headerProps={props.headerProps} />
    </div>
    <div className="book_col right">{props.items}</div>
  </div>
);

export default book
